import { apiSlice } from "@app/api/apiSlice";

export const shippingPartnerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllShippingPartner: builder.mutation({
      query: (query) => ({
        url: `shippingpartner/shippingpartner?${query}`,
      }),
    }),
    loadOneShippingPartner: builder.mutation({
      query: (id) => ({
        url: `shippingpartner/shippingpartner/${id}`,
      }),
    }),
    deleteShippingPartner: builder.mutation({
      query: (id) => ({
        url: `shippingpartner/delete/${id}`,
        method: "DELETE",
      }),
    }),
    saveShippingPartner: builder.mutation({
      query: (body) => ({
        url: `shippingpartner/admin`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLoadAllShippingPartnerMutation,
  useSaveShippingPartnerMutation,
  useLoadOneShippingPartnerMutation,
  useDeleteShippingPartnerMutation,
} = shippingPartnerApiSlice;
